import { renderGroupContent } from './utilities';

export function GroupContent({ group, backgroundColor }) {
  return renderGroupContent(group, backgroundColor);
}
